// extracted by mini-css-extract-plugin
module.exports = {"root":"errorView-root-Rzs","content":"errorView-content-hsg","header":"errorView-header-Kzb","message":"errorView-message-F0k","actionsContainer":"errorView-actionsContainer-bf5"};